import {useContext, useEffect, useState} from "react";
import './hotel.css';
import { PaymentContext } from "../Payments/PaymentContext";
import { useNavigate } from "react-router";
import {Button, Typography} from '@mui/material'

export default function BookHotels(){
    const [dataObtained, setDataObtained] = useState([]);
    const [date, setDate] = useState(new Date());
    const [tomorrow, setTomorrow] = useState(new Date());
    const {setPrice, setSurcharge} = useContext(PaymentContext);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(true);

    useEffect(()=>{ 
        window.scrollTo(0, 0);
        const url = 'https://content.newtonschool.co/v1/pr/63b85bcf735f93791e09caf4/hotels';
        fetch(url)
    .then((res)=>{
        res.json()
        .then((data)=>{
            setDataObtained(data);
            setLoader(false);
        })
    })
    const d = new Date();
    d.setDate(d.getDate() + 1);
    setTomorrow(d);
    } , [])
    return (
       <>
        {loader ? <div className="loader">
            <img src="/loader.gif" style={{width:'100px', height:'100px'}}/>
        </div> : 
        
        <>
            <h3 style={{marginLeft: '16vw'}}>Available Hotels</h3>
        <div className="ticket-container">
            {dataObtained.map((el, idx)=>{
                return (
                    <div className="tkt-box2" key={idx}>
                        <table>
                            <tr>
                                <td>HOTEL</td>
                                <td>CHECK-IN</td>
                                <td>PRICE:</td>
                            </tr>
                            <tr>
                                <td><Typography 
                                variant="h4"
                                sx={{lineHeight:'1'}}
                                >{el.hotel_name}</Typography></td>
                                <td><h4>{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.price_per_night}</td>
                            </tr>
                            <tr>
                                <td>CITY</td>
                                <td>CHECK-OUT</td>
                                <td>ROOM:</td>
                            </tr>
                            <tr>
                                <td><Typography
                                variant="h4"
                                sx={{lineHeight:'1'}}
                                >{el.city}</Typography></td>
                                <td><h4>{tomorrow.getDate()}-{tomorrow.getMonth()}-{tomorrow.getFullYear()}</h4></td>
                                <td>{el.room_type}</td>
                            </tr>
                            <tr>
                                <td>RATING:</td>
                                <td>GUEST:</td>
                            </tr>
                            <tr>
                                <td><h4>{el.rating}/10</h4></td>
                                <td><h4>{el.guests}</h4></td>
                            </tr>
                        </table>
                        <Button
                        variant="contained"
                        sx={{float:'right', marginBottom:'20px', marginRight:'20px'}} 
                        id={el.price_per_night} 
                        onClick={(e)=>{
                            e.persist();
                            setPrice(parseInt(e.currentTarget.id));
                            setSurcharge(parseInt(e.currentTarget.id)*0.25);
                            navigate('/payments');
                        }
                        }>BOOK</Button>
                    </div>
                )
            })}
        </div>
        </>}
       </> 
    )
}